export class UserContextLoadError extends Error {
  readonly cause: unknown;

  constructor(cause: unknown) {
    super('Failed to load user context after 3 attempts.');
    this.name = 'UserContextLoadError';
    this.cause = cause;
  }
}

export const isUserContextLoadError = (error: unknown): error is UserContextLoadError => {
  return error instanceof UserContextLoadError;
};
